import React from "react";

export default function LogoutButton({ setIsLoggedIn, resetAppState }) {
  function handleLogoutButtonClick() {
    resetAppState();
  }

  return <button onClick={handleLogoutButtonClick}>Logout</button>;
}
